import type { TripGpsDistance } from '../trips.api';

export interface GpsDistanceLabel {
  text: string;
  /** Under 80 per cent of the trip had a fix, so the figure is a floor; the screen says so beside it. */
  isLowCoverage: boolean;
}

const KM_FORMAT = new Intl.NumberFormat('en-KE', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

/** A trip with no figure reads "Not available", never "0.0 km": no fixes is not the same as not moving. */
export function gpsDistanceLabel(gpsDistance: Pick<TripGpsDistance, 'distanceM' | 'isLowCoverage'> | null): GpsDistanceLabel {
  if (!gpsDistance) return { text: 'Not available', isLowCoverage: false };
  return { text: `${KM_FORMAT.format(gpsDistance.distanceM / 1000)} km`, isLowCoverage: gpsDistance.isLowCoverage };
}
